import { merge } from 'lodash/fp';
import { constArraytoObj, constArraytoActionObj } from '../utils/action.utils';

const actions = [
  'UPDATE_BACKEND_ERROR',
  'CLEAR_BACKEND_ERROR',
];

export default merge(constArraytoObj(actions), constArraytoActionObj(actions));
